import { merge, map, parseInt } from 'lodash'
import 'jquery-ui/ui/core'
import 'jquery-ui/ui/widgets/sortable'
import $ from 'jquery'

export default {
  inserted (el, binding) {
    $(el).sortable(merge({
      handle: '.move',
      helper: 'clone',
      cursorAt: { left: 0, top: 0 },
      update: (event, ui) => {
        let sorted = map($(el).sortable('toArray', { attribute: 'data-sortable-id' }), (value, key) => {
          return { id: parseInt(value), order: ++key }
        })

        if (binding.value && binding.value.sorted) {
          binding.value.sorted(sorted)
        }
      }
    }, binding.value ? binding.value.options : {}))
  }
}



// WEBPACK FOOTER //
// ./src/directives/sortable.js